// extracted by mini-css-extract-plugin
export var root_reset = "plasmic_starter_blog-module--root_reset--3lPr-";